import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as svc from "../../api/toothService";
import { getApiErrorMessage } from "../../utils/apiError";

export const fetchTeeth = createAsyncThunk("tooth/fetchAll", async (params) => {
  const res = await svc.getTeeth(params);
  return res.data;
});

export const createToothThunk = createAsyncThunk("tooth/create", async (data, { rejectWithValue }) => {
  try {
    const res = await svc.createTooth(data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to create tooth."));
  }
});

export const updateToothThunk = createAsyncThunk("tooth/update", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await svc.updateTooth(id, data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to update tooth."));
  }
});

export const deleteToothThunk = createAsyncThunk("tooth/delete", async (id, { rejectWithValue }) => {
  try {
    await svc.deleteTooth(id);
    return id;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to delete tooth."));
  }
});

const toothSlice = createSlice({
  name: "tooth",
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeeth.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchTeeth.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchTeeth.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createToothThunk.fulfilled, (state, action) => { state.list.push(action.payload); })
      .addCase(updateToothThunk.fulfilled, (state, action) => {
        const id = action.payload.toothID || action.payload.id;
        const idx = state.list.findIndex((t) => (t.toothID || t.id) === id);
        if (idx !== -1) state.list[idx] = action.payload;
      })
      .addCase(deleteToothThunk.fulfilled, (state, action) => {
        state.list = state.list.filter((t) => (t.toothID || t.id) !== action.payload);
      });
  },
});

export default toothSlice.reducer;
